import React from 'react';
import { Link, NavLink, useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { CABINET_SLUG, getDepartmentChildren } from '../../config';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';


const SubmenuOnPageTop = ({ is_moderator, is_staff, is_teacher,
                            yandex_saved_payment, paypal_subscription, ...counters }) => {
  let location = useLocation();
  const { lang } = useParams();
  const params = location.pathname.split('/').filter(i => ![lang, CABINET_SLUG, ''].includes(i));
  let list = [];
  if (params.length){
    const findParam = params[0];
    let tree = getDepartmentChildren(findParam);
    const root = '/' + lang + '/' + CABINET_SLUG + '/' + findParam + '/';
    if (tree){
      for (const [key, value] of Object.entries(tree)) {
        let item = null;
            if (value.old_version){
               let href = root + key + '/';
               item = <a href={ href } className={'d-flex flex-column cabinet-submenu'}>
              { value.title }
               </a>
            } else {
              item = <div key={key} className={'d-flex flex-column cabinet-submenu'}>
                <NavLink to={root + key + '/'} activeClassName="text-orange" className={'white-space-nowrap'}>
                  { value['title'] }{ value['counter'] && <span> ({ counters[value['counter']['key']] })</span>}
                </NavLink>
              </div>
            };

        if (value.is_moderator) {
          if (is_moderator) list.push(item);
          continue;
        }
        if (value.is_staff) {
          if (is_staff) list.push(item);
          continue;
        }
        if (value.is_teacher) {
          if (is_teacher) list.push(item);
          continue;
        }
        if (value.yandex_saved_payment) {
          if (yandex_saved_payment) list.push(item);
          continue;
        }
        if (value.paypal_subscription) {
          if (paypal_subscription) list.push(item);
          continue;
        }
        list.push(item);
      }
    }
  }
  if (list.length) return <div className='my-3 d-flex flex-wrap flex-row justify-content-center small'>{ list }</div>
  return null;
}

SubmenuOnPageTop.propTypes = {
  is_moderator: PropTypes.bool.isRequired,
  is_staff: PropTypes.bool.isRequired,
  is_teacher: PropTypes.bool.isRequired,
  yandex_saved_payment: PropTypes.bool.isRequired,
  paypal_subscription: PropTypes.bool.isRequired,

  moderatorCounter: PropTypes.number.isRequired,
  moderatorArrangementCounter: PropTypes.number.isRequired,
  moderatorLessonsCounter: PropTypes.number.isRequired,

  arrangementCounter: PropTypes.number.isRequired,
  lessonsCounter: PropTypes.number.isRequired,
  couponsCounter: PropTypes.number.isRequired,
  favoritesCounter: PropTypes.number.isRequired,
  cartCounter: PropTypes.number.isRequired,
  notificationsCounter: PropTypes.number.isRequired,
  messagesCounter: PropTypes.number.isRequired,
  commentsCounter: PropTypes.number.isRequired,
  aphorismsCounter: PropTypes.number.isRequired,
  collectionsCounter: PropTypes.number.isRequired,
  playlistsCounter: PropTypes.number.isRequired,
  authorsCounter: PropTypes.number.isRequired,
  genresCounter: PropTypes.number.isRequired,
}

let mapStateToProps = (state) => {
  return {
    is_moderator: state.auth.is_moderator,
    is_staff: state.auth.is_staff,
    is_teacher: state.auth.is_teacher,
    yandex_saved_payment: state.auth.yandex_saved_payment,
    paypal_subscription: state.auth.paypal_subscription,

    moderatorCounter: state.auth.moder_count,
    moderatorArrangementCounter: state.shop.arrangements_moder_count,
    moderatorLessonsCounter: state.shop.lessons_moder_count,

    arrangementCounter: state.shop.arrangements_count,
    lessonsCounter: state.shop.lessons_count,
    couponsCounter: state.auth.coupons_count,
    favoritesCounter: state.auth.favorites_count,
    cartCounter: state.auth.cart_count,
    notificationsCounter: state.auth.notifications_count,
    messagesCounter: state.auth.messages_count,
    commentsCounter: state.auth.comments_count,
    aphorismsCounter: state.auth.aphorisms_count,
    collectionsCounter: state.auth.collection_arrangements_count,
    playlistsCounter: state.auth.collection_playlists_count,
    authorsCounter: state.auth.collection_authors_count,
    genresCounter: state.auth.collection_genres_count,
  }
};

export default compose(
  connect(mapStateToProps),
)(SubmenuOnPageTop);
